import { defineMessages } from 'react-intl';

export default defineMessages({
    //DE15345 changed the messages for cancel pop-up
    agencyCancelTitle: {
        id: 'agency.admin.views.messages.agencyCancelTitle',
        defaultMessage: 'Changes will not be saved'
    },
    cancelMessage: {
        id: 'agency.admin.views.messages.cancelMessage',
        defaultMessage: 'Are you sure you want to exit without submitting?'
    },
    confirmButtonText: {
        id: 'agency.admin.views.messages.confirmButtonText',
        defaultMessage: 'Yes'
    },
    cancelButtonText: {
        id: 'agency.admin.views.messages.cancelButtonText',
        defaultMessage: 'No'
    },
    // Added Validation Messages for PhoneNumber field
    PhoneValidationMessage: {
        id: 'agency.admin.views.messages.Value must be a valid phone number of type xxx-xxx-xxxx',
        defaultMessage: 'Value must be a valid phone number of type xxx-xxx-xxxx',
    },
    PhoneValidationRequiredMessage: {
        id: 'agency.admin.views.messages.This is a required field.',
        defaultMessage: 'This is a required field.',
    },
    RoleValidationTitle: {
        id: 'twia.addNewUser.views.Please Select Role',
        defaultMessage: 'Please Select Role',
    },
    RoleValidationMessage: {
        id: 'twia.addNewUser.views.At least one role must be selected',
        defaultMessage: 'At least one role must be selected',
    },
    RoleButtonCloseMessage:{
        id: 'twia.addNewUser.views.Close',
        defaultMessage: 'Close',
    },
});